import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { EffectsModule } from '@ngrx/effects';
import {
  provideStoreDevtools,
  StoreDevtoolsModule,
} from '@ngrx/store-devtools';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AppLocaleModule } from './app-locale.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { OAuthModule } from 'angular-oauth2-oidc';
import { AppHttpInterceptor } from './interceptors/app-http-interceptor.interceptor';
import { DialogService } from 'primeng/dynamicdialog';
import { AuthGuard } from './guards';
import { TruncateCharPipe } from './pipes/truncate-char.pipe';
import { UpperFirstPipe } from '@z-trippete/angular-pipes';
import { SigninGuard } from './guards/signin.guard';
import {
  CurrencyPipe,
  DATE_PIPE_DEFAULT_OPTIONS,
  DatePipe,
} from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RootStoreModule } from '@booking-booster-client/root-store';
import { environment } from '../environments/environment';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';
import { AuthInitializationGuard } from './guards/auth-initialize.guard';
import { ToCurrencyPipe } from '@booking-booster-client/pipes';
import { RouterModule } from '@angular/router';
import { TourPrimeNgModule } from 'ngx-ui-tour-primeng';

const BBPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{indigo.50}',
      100: '{indigo.100}',
      200: '{indigo.200}',
      300: '{indigo.300}',
      400: '{indigo.400}',
      500: '{indigo.500}',
      600: '{indigo.600}',
      700: '{indigo.700}',
      800: '{indigo.800}',
      900: '{indigo.900}',
      950: '{indigo.950}',
    },
  },
});

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    ToastModule,
    BrowserModule,
    AppLocaleModule,
    RootStoreModule,
    AppRoutingModule,
    ConfirmDialogModule,
    BrowserAnimationsModule,
    FormsModule,
    TranslateModule,
    TruncateCharPipe,
    RouterModule,
    TourPrimeNgModule,
    OAuthModule.forRoot(),
    EffectsModule.forRoot([]),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
  ],
  providers: [
    DatePipe,
    AuthGuard,
    SigninGuard,
    CurrencyPipe,
    DialogService,
    ToCurrencyPipe,
    MessageService,
    UpperFirstPipe,
    ConfirmationService,
    AuthInitializationGuard,

    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useValue: { dateFormat: 'shortDate' },
    },

    {
      provide: LOCALE_ID,
      useValue: 'it-IT',
    },

    { provide: HTTP_INTERCEPTORS, useClass: AppHttpInterceptor, multi: true },
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: BBPreset,
        options: {
          darkModeSelector: '.bb-dark-version',
          cssLayer: { name: 'primeng', order: 'theme, base, primeng' },
        },
      },
    }),
    provideHttpClient(withInterceptorsFromDi()),
    provideStoreDevtools({
      name: 'booking-booster',
      maxAge: 30,
      trace: true,
      connectInZone: true,
    }),
  ],
})
export class AppModule {}
